import { UsersTable } from '@/components/features/users'

export const Adminstrations = () => {
  return (
    <div >
      <UsersTable />
    </div>
  )
}
